var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-4"},[_c('search-client',{attrs:{"size":"sm"},on:{"client-is-set":_vm.setClientId,"searching-client":_vm.resetClient}})],1)]),_vm._v(" "),(_vm.pivotDisplay)?_c('WebDataRocks',{key:_vm.key,attrs:{"report":_vm.pivotConfig,"global":_vm.pivotGlobal,"toolbar":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }